import homeRoutes from "./pages/home";

import login from "./pages/login.vue";
import schedule from "@/pages/home/schedule.vue";
import member from "@/pages/home/member.vue";

const token = localStorage.getItem("token");

const routes: any[] = [
  {
    layout: token ? "home-layout" : "",
    name: "root",
    path: "/",
    component: token ? member : login,
  },
  ...homeRoutes,
];

export default routes;
